import { createAction, union } from '@ngrx/store';
import { Code } from 'src/app/models/area-restaurant/code.model';
import { Restaurant } from 'src/app/models/area-restaurant/restaurant.model';

interface Data {
  largeArea: Code;
  mediumArea: Code;
  smallArea: Code;
  currentGenre: Code;
  relatedArea: Code[];
  genresInArea: Code[];
  totalCount: number;
  restaurants: Restaurant[];
}

export const storeInitialData = createAction(
  'AreaRestaurantPageActions storeInitialData',
  (payload: { data: Data; page: number }) => ({ payload }),
);

export const storePrevPageRestaurants = createAction(
  'AreaRestaurantPageActions storePrevPageRestaurants',
  (payload: { restaurants: Restaurant[]; page: number }) => ({
    payload,
  }),
);

export const storeNextPageRestaurants = createAction(
  'AreaRestaurantPageActions storeNextPageRestaurants',
  (payload: { restaurants: Restaurant[]; page: number }) => ({
    payload,
  }),
);

const all = union({
  storeInitialData,
  storePrevPageRestaurants,
  storeNextPageRestaurants,
});

export type AreaRestauranPageActionsUnion = typeof all;
